<div class="main-content">
  <div fxLayout="row" fxLayoutAlign="space-between end">
    <div>
      <h1>{{ "releasenote_title" | translate }}</h1>
    </div>
    <div>
      <button
        class="button-close"
        id="btn_close"
        data-testid="btn_close"
        mat-fab
        (click)="closeReleaseNote()"
      >
        <mat-icon> close</mat-icon>
      </button>
    </div>
  </div>
  @for (noteVersion of releaseNoteVersions; track noteVersion) {
  <div>
    <h5 class="version-title">{{ noteVersion.Version }}</h5>
    @for (note of noteVersion.ReleaseNotes; track note) {
    <div class="release-note-container">
      <div
        fxLayout="row"
        class="font-size-headline"
        fxLayoutAlign="start"
        fxLayoutGap="5px"
      >
        <div>
          <button
            class="button-note-type"
            id="btn_notetype_{{ note.Version }}"
            mat-fab
          >
            <mat-icon>
              {{ getNoteTypeIcon(note.ReleaseNoteType.Name) }}</mat-icon
            >
          </button>
        </div>
        <div class="notetype-name">{{ note.ReleaseNoteType.Name }}</div>
      </div>
      <div class="divider"></div>
      <div
        class="note-content"
        [innerHTML]="note.Description | safe : 'html'"
      ></div>
    </div>
    }
    <div class="divider"></div>
  </div>
  }
  <div class="divider"></div>
  <div class="close-button">
    <button
      type="submit"
      mat-raised-button
      id="releasenote_close"
      data-testid="releasenote_close"
      (click)="closeReleaseNote()"
    >
      {{ "releasenote_close" | translate }}
    </button>
  </div>
</div>
